import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
})
export class FileManagerComponent implements OnInit {
  @Output() selectedFiles = new EventEmitter<any[]>();
  @Output() deletedFilesList = new EventEmitter<[]>();
  @Output() previewFile = new EventEmitter<boolean>();

  @Input() files: any = [];
  @Input() docsEditable = true;
  @Input() maxFiles = 5;
  @Input() maxFileSize = 10;
  @Input() managerIndex: any = '0'; // For input id multi file manager in one view
  @Input() label!: string;
  @Input() isRequired = false;
  @Input() isSubmitted = false;
  @Input() isDisabled = false;
  @Input() cols = 1;
  @Input() mode: "inline" | "box" | "inline-profile" = "inline";
  @Input() isPreview = false;
  @Input() loading = false;

  @Input() allowedExt: any[] = [
    'pdf',
    'jpeg',
    'jpg',
    'png',
    'doc',
    'docx',
    'wpd',
    'tex',
    'ppt',
    'pptx',
    'xlsx',
    'xls',
    'zip',
    'rar',
    'csv'
  ];

  @Input() renderBtn = false;
  // Uploader
  @Input() isUploader = false;
  @Input() uplodaerType = 0;
  uploadedFilesArr: any = [];
  @Input() uploadPath = 'job/assessment'

  /////
  selectedfilesCount = 0;
  deletedFiles: any = [];
  validFile = true;
  fileMaxSiZeErorr = false;
  fileMaxNameSiZeErorr = false;


  @Output() uploadLoaing = new EventEmitter<boolean>();
  AcceptedExtentions!: string
  constructor(private service: ApiServiceService) { }

  ngOnInit() {
    // this.files.map((file: any) => {
    //   file.name = file.filePath
    // });
    // if (this.files.length && this.isUploader) {
    //   this.files.forEach(file => {
    //     this.uploadedFilesArr.push({
    //       fileName: file.name,
    //       fileUpload: file.token
    //     });
    //   });
    //   this.selectedFiles.emit(this.uploadedFilesArr);
    // }

    if (this.allowedExt) {
      this.AcceptedExtentions = '.' + this.allowedExt.join(', .');
    }
  }

  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (this.allowedExt) {
      this.AcceptedExtentions = '.' + this.allowedExt.join(', .');
    }
  }

  validFileType(fileName: string) {
    const extension = fileName.split('.').pop()?.toLowerCase();
    const extensionUpper = fileName.split('.').pop()?.toUpperCase();

    if (!(this.allowedExt.includes(extension) || this.allowedExt.includes(extensionUpper))) {
      return false;
    }
    return true;
  }
  fileExt(fileName: string) {
    const x = fileName?.split('.');
    const extension = x[x.length - 1]?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      case 'doc':
      case 'docx':
      case 'wpd':
      case 'tex':
        return 'doc';
      case 'xlsx':
        return 'xlsx';
      case 'xls':
      case 'csv':
        return 'xls';
      case 'zip':
      case 'rar':
        return 'zip';
      case 'ppt':
      case 'pptx':
        return 'pptx';
      case 'mp4':
        return 'mp4';
      case 'mpg':
        return 'video';
      case 'webm':
        return 'webm';
      case 'mov':
        return 'mov';
      case 'mp3':
        return 'mp3';
      case 'wav':
        return 'wav';
      case 'aac':
        return 'aac';
      default:
        return false;
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
    event.target.value = '';
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number, id: any) {
    if (id) {
      this.deletedFiles.push(id);
    }

    const deleted = this.files[index];
    this.files.splice(index, 1);

    if (this.isUploader) {
      const deletedIndx = this.uploadedFilesArr.findIndex((item: any) => item.fileUpload === deleted.token);
      this.uploadedFilesArr.splice(deletedIndx, 1);
      this.selectedFiles.emit(this.uploadedFilesArr);
    } else {
      this.selectedFiles.emit(this.files);
      this.deletedFilesList.emit(this.deletedFiles);
    }
    this.selectedfilesCount = this.files.length;
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    const filesToUpload = [];
    this.validFile = true;
    this.selectedfilesCount = this.files.length + files.length;
    if (this.selectedfilesCount > this.maxFiles) {
      return;
    }
    for (let item of files) {
      if (this.validFileType(item.name)) {
        this.validFile = true;
      } else {
        this.validFile = false;
      }

      // Check file and push to array files
      if (item.size / (1024 * 1024) <= this.maxFileSize && this.validFileType(item.name)) {
        item.fileType = this.fileExt(item.name);
        this.files.push(item);
        filesToUpload.push(item);

        if (this.isUploader) {
          // this.uploadFile(filesToUpload);
          this.uploadFileWithAPI(item)
        } else {
          this.selectedFiles.emit(this.files);
        }

        if (item.size / (1024 * 1024) <= this.maxFileSize) {
          this.fileMaxSiZeErorr = false;
        }
      } else {
        if (item.size / (1024 * 1024) > this.maxFileSize) {
          this.fileMaxSiZeErorr = true;
        }
      }
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadFile(files: any) {
    this.loading = true;
    this.isDisabled = true;
    // this.service.upload_file(files, this.uplodaerType).subscribe(
    //   (response) => {
    //     this.loading = false;
    //     this.Disapled = false;
    //     this.uploadedFilesArr.push(response.data);
    //     this.selectedFiles.emit(this.uploadedFilesArr);
    //   },
    //   (err) => {
    //     this.loading = false;
    //     this.Disapled = false;
    //   }
    // );
  }

  uploadFileWithAPI(file: any) {
    this.uploadLoaing.emit(true);
    this.loading = true;
    this.isDisabled = true;
    this.service.uploadFile(file, this.uploadPath).subscribe(
      (response) => {
        this.uploadLoaing.emit(false);
        this.loading = false;
        this.isDisabled = false;
        let file = {
          orginalFileName: response.data.orginalFileName,
          fileName: response.data.fileName
        }
        this.selectedFiles.emit([file]);
      },
      (err) => {
        this.uploadLoaing.emit(false);
        this.loading = false;
        this.isDisabled = false;
      }
    );
  }


  previewPdf() {
    this.previewFile.emit(true);
  }


  fileName(text: string) {
    let x = text?.split('.');
    x.pop();
    return x.join('.');
  }
}
